import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'

import store from '@/vuex/store'
import routes from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth !== undefined && to.meta.auth === true) {
    if (store.state.userdata == null) {
      next('/login')
    }
  }
  if (to.meta.guest !== undefined && to.meta.guest === true) {
    // this route check if user have logged in redirect to home page
    if (store.state.userdata !== null) {
      next('/')
    }
  }
  if (to.meta.verified !== undefined && to.meta.verified === true) {
    // this route check if user have logged in redirect to home page
    if (store.state.userdata.logistic_company.document_status !== 'disetujui' || store.state.userdata.logistic_company.account_status !== 'aktif') {
      next('/403')
    }
  }
  next()
})

export default router
